export enum DebounceInputEvent {
    Blur = 'blur',
    Enter = 'keyup',
    Input = 'input',
}
